import React, { memo } from 'react';

import { clsx } from 'clsx';
import Image from 'next/image';

import BaikalLogo from '@shared/assets/icons/baikal.svg';
import CdekLogo from '@shared/assets/icons/cdek.svg';
import { DeliveryCompany } from '@shared/types/enums/delivery.enum';
import { HStack } from '@shared/ui/Stack';
import { Tab, TabList, TabPanel, Tabs } from '@shared/ui/Tabs';

import clsMain from '../Form/Form.module.scss';
import cls from './DeliveryService.module.scss';

type DeliveryServiceProps = {
  onChangeDeliveryCompany: (tab: string) => void;
  onClickOpenCdekWidget: () => void;
  errorDeliveryPoint?: string;
  deliveryAddress?: string;
};

export const DeliveryService = memo<DeliveryServiceProps>(
  ({ deliveryAddress, errorDeliveryPoint, onClickOpenCdekWidget, onChangeDeliveryCompany }) => (
    <div className={clsMain.plate}>
      <h2 className={clsMain.title}>Выбор службы доставки</h2>
      <Tabs defaultActiveTab={DeliveryCompany.CDEK}>
        <TabList className={clsMain.tabList}>
          <Tab
            className={clsMain.tab}
            activeClassName={clsMain.activeTab}
            value={DeliveryCompany.CDEK}
            onClick={onChangeDeliveryCompany}
          >
            СДЭК
          </Tab>
          <Tab
            className={clsMain.tab}
            activeClassName={clsMain.activeTab}
            value={DeliveryCompany.BAIKAL}
            onClick={onChangeDeliveryCompany}
          >
            Байкал сервис
          </Tab>
        </TabList>
        {errorDeliveryPoint && <div className={cls.error}>{errorDeliveryPoint}</div>}
        <TabPanel
          className={cls.tabPanel}
          value={DeliveryCompany.CDEK}
        >
          <HStack className={cls.info}>
            <Image
              src={CdekLogo}
              width={68}
              alt={''}
            />
            <div className={cls.description}>Вы можете оформить доставку по СДЭК и получить заказ в короткий срок</div>
          </HStack>
          <div className={clsx(clsMain.plate, cls.selectPointPlate)}>
            <HStack className={cls.titleWrapper}>
              <h3 className={cls.title}>Выбор города и пункта выдачи</h3>
              {!deliveryAddress && (
                <div
                  className={cls.button}
                  onClick={onClickOpenCdekWidget}
                >
                  Выбрать
                </div>
              )}
            </HStack>
            {deliveryAddress && (
              <HStack className={cls.selectedInfo}>
                <div>
                  <div className={cls.title}>Вы выбрали:</div>
                  <div className={cls.description}>{deliveryAddress}</div>
                </div>
                <div
                  className={cls.button}
                  onClick={onClickOpenCdekWidget}
                >
                  Изменить
                </div>
              </HStack>
            )}
          </div>
        </TabPanel>
        <TabPanel
          className={cls.tabPanel}
          value={DeliveryCompany.BAIKAL}
        >
          <HStack className={cls.info}>
            <Image
              src={BaikalLogo}
              width={108}
              alt={''}
            />
            <div className={cls.description}>
              Вы можете оформить доставку через транспортную компанию Байкал сервис для экономичной перевозки крупных
              заказов
            </div>
          </HStack>
        </TabPanel>
      </Tabs>
    </div>
  )
);
